import script from "./InstagramModalProduct.vue?vue&type=script&lang=ts&setup=true"
export * from "./InstagramModalProduct.vue?vue&type=script&lang=ts&setup=true"

import "./InstagramModalProduct.vue?vue&type=style&index=0&id=50bb5094&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50bb5094"]])

export default __exports__